import { useEffect, useState } from "react";
import { progressScheduleInterface } from "../static/interface/reservationHome.interface";
import { progressScheduleSort } from "../../../Common/ts/hooks.tools";
import { QueryObserverResult, RefetchOptions } from "@tanstack/react-query";

const useProgressScheduleDataAllScheduleType = (
    {
        contractProgressScheduleDataList,
        contractProgressScheduleDataListIsLoading,

        singleShotProgressScheduleDataList,
        singleShotProgressScheduleDataListIsLoading,
    }:{
        contractProgressScheduleDataList: progressScheduleInterface[];
        contractProgressScheduleDataListIsLoading: boolean;

        singleShotProgressScheduleDataList: progressScheduleInterface[];
        singleShotProgressScheduleDataListIsLoading: boolean;
    }
) => {

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [progressScheduleDataList, setProgressScheduleDataList] = useState<progressScheduleInterface[]>([]);

    useEffect(() => {
        let before_progress_schedule_data: progressScheduleInterface[] = [];

        let contract_progress_schedule_data: progressScheduleInterface[] = [];
        if(!!contractProgressScheduleDataList){
            contract_progress_schedule_data = [...contractProgressScheduleDataList];
        }

        let single_shot_progress_schedule_data: progressScheduleInterface[] = [];
        if(!!singleShotProgressScheduleDataList){
            single_shot_progress_schedule_data = [...singleShotProgressScheduleDataList];
        }

        before_progress_schedule_data = [...contract_progress_schedule_data, ...single_shot_progress_schedule_data];
        before_progress_schedule_data.sort(progressScheduleSort);

        setProgressScheduleDataList(before_progress_schedule_data);
    }, [contractProgressScheduleDataList, singleShotProgressScheduleDataList])

    useEffect(() => {
        setIsLoading(!!contractProgressScheduleDataListIsLoading || !!singleShotProgressScheduleDataListIsLoading);
    }, [contractProgressScheduleDataListIsLoading, singleShotProgressScheduleDataListIsLoading])

    return ({
        progressScheduleDataList,
        isLoading,
    })
}

export default useProgressScheduleDataAllScheduleType;